import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, ownerOnly = false }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-foreground font-mono text-xs tracking-[0.2em] uppercase">
        — Verifying session —
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: loc }} replace />;
  }
  if (ownerOnly && !user.owner) {
    return <Navigate to="/app/rooms" replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/app/rooms" replace />;
  }
  return children;
}
